// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__SrIh2","modalInternal":"Modal_modalInternal__DHdjW","closeButton":"Modal_closeButton__uqxlT"};